export default {
    "meta-title-base": "МЦ Уни Хоспитал София",
    "meta-title-team": "Екип",
    "meta-title-venous-center": "Венозен център",
    "meta-title-about": "За нас",
    "meta-title-book-appointment": "Запази час",
    "meta-title-contacts": "Контакти",
    "meta-title-news": "Новини",
    "meta-title-services": "Услуги",
    "meta-title-categories": "Категории",
    "meta-title-doctors": "Специалисти",
    "meta-title-offices": "Кабинети",

    "home": "Начало",
    "navigation": "Навигация",
    "offices": "Кабинети",
    "team": "Екип",
    "venous-center": "Венозен център",
    "services": "Услуги",
    "about-us": "За нас",
    "news": "Новини",
    "contacts": "Контакти",
    "home-heading-video-title-line-1": "Навременна грижа",
    "home-heading-video-title-line-2": "за теб и цялото семейство!",
    "home-heading-video-description": "МЦ Уни Хоспитал – София разполага с медицинска апаратура от най-съвременен тип, която е верен помощник на специалистите при персонализираната профилактика, диагностика и лечение.",
    "home-heading-button-solid": "Нашите услуги",
    "home-heading-button-outline": "Kабинети",
    "home-heading-play-button": "Изгледай цялото видео",
    "office-1": "Медицинска онкология",
    "office-2": "Лъчетерапия",
    "office-3": "Пластично-възстановителна и естетична хирургия",
    "office-4": "Съдова хирургия",
    "office-5": "Дерматология",
    "office-6": "Кардиология",
    "index-specialties-offices-title": "Специалности и кабинети",
    "index-specialties-offices-subtitle": "Разгледайте всички",
    "index-specialties-offices-description": "Екипът от утвърдени специалисти в медицинския център ще помогне на повече хора с първокласни медицински услуги - диагностична, терапевтична и превантивна дейност.",
    "index-about-title-1": "За МЦ \"Уни Хоспитал\" - София",
    "index-about-title-2": "Екип\n" + "от специалисти",
    "index-about-description-1": "Медицински център Уни Хоспитал – София осигурява високоспециализирана извънболнична медицинска помощ. В центъра работят доказани в областта си специалисти с дългогодишна практика. " +
        "МЦ Уни Хоспитал – София разполага с медицинска апаратура от най-съвременен тип, която е верен помощник на специалистите при персонализираната профилактика, диагностика и лечение.",
    "index-about-description-2": "Медицински център Уни Хоспитал – София осигурява високоспециализирана извънболнична медицинска помощ. В центъра работят доказани в областта си специалисти с дългогодишна практика.",
    "index-about-placeholder-1": "Научете повече за нас",
    "index-about-placeholder-2": "Научете повече за екипа ни",
    "index-about-doctor-title": "Д-р Светослав Димитров, дм, Съдова хирургия",
    "index-about-doctor-subtitle": "Управител на МЦ \"Уни Хоспитал\" - София",
    "index-services-title": "Услуги",
    "index-services-description": "В МЦ \"Уни Хоспитал\" - София се предлагат над 120 услуги в над 20 специалности и направления",
    "service-category-1": "Общи медицински услуги",
    "service-category-2": "Кардиологични услуги",
    "service-category-3": "Хирургични услуги",
    "service-category-4": "Манипулации",
    "service-category-5": "Лъчелечение",
    "index-services-button": "Виж всички услуги",
    "all-services": "Всички услуги",
    "index-compare-title": "Венозен център",
    "index-compare-description": "Венозният център на „МЦ Уни Хоспитал“ – София разполага с последно поколение оборудване за лечение на разширени вени, а медицинските специалисти, работещи в него, са с най-високо ниво на компетентност. Ние във Венозен център на „МЦ Уни Хоспитал“ – София вярваме, че Вие избирате не просто място и екип, а хора, на които да доверите грижата за най-ценното – Вашето здраве.",
    "index-news-title": "Последни новини",
    "index-news-description": "Научете за нашите инициативи и най-актуалното от активностите ни.",
    "index-news-button": "Всички новини",
    "working-days": "Пон-Пет",
    "working-hours": "9:00 - 18:00ч",
    "unihospital-address": "гр. София, п.к. 1680, ул. „Околовръстен път“ № 27",
    "copyright-all-rights-reserved": "© 2016 - 2024 МБАЛ Уни Хоспитал - Всички права запазени.",
    "privacy-policy": "Политика за поверителност",
    "terms-and-conditions": "Общи условия",
    "book-appointment": "Запази час",
    "book-appointment-online": "Запази час",
    "gallery": "Галерия",
    "learn-more": "Научете повече",
    "one-specialist-description-title": "Биография и професионален опит",
    "one-office-information-title": "Информация",
    "one-office-specialists-title": "Специалисти",
    "team-page-title": "Екип от специалисти",
    "team-heading-paragraph": "В МЦ \"Уни Хоспитал\" - София, вярваме в силата на професионализма, иновациите и индивидуалния подход към всеки пациент. Гордеем се с нашия екип от висококвалифицирани специалисти, които са посветени на Вашето здраве.",
    "team-heading-filter-placeholder": "Филтрирай специалистите по специалност",
    "team-button-choose-specialty": "Изберeте специалност",
    "services-page-title-1": "Услуги",
    "services-page-title-2": "Изберете категория услуги",
    "services-page-subtitle": "Най-търсени услуги",
    "one-category-bottom-title": "Не откривате услугата, която търсите?",
    "one-category-bottom-subtitle": "Нашият екип от специалисти е насреща за Вашите въпроси.",
    "contact-us": "Свържете се с нас",
    "one-service-bottom-title": "Още услуги",
    "news-page-title": "Новини",
    "one-news-page-bottom-title": "Oще новини",
    "contacts-title": "Свържете се с нас",
    "contacts-phone-placeholder": "Телефон",
    "contacts-address-placeholder": "Адрес",
    "contacts-phone-number": "0884 64 87 11",
    "contacts-email-address": "mc.sofia@unihospitalbg.bg",
    "contacts-hospital-address": "гр. София, п.к. 1680, ул. „Околовръстен път“ № 27",
    "contacts-working-hours-placeholder": "Работно време",
    "contacts-working-days-working-hours": "Понеделник до петък – 9.00 – 18.00",
    "contacts-rest-days": "Събота и неделя – почивен ден",
    "send-inquiry": "Изпратете запитване",
    "contacts-modal-title": "Изпратете запитване",
    "contacts-modal-subtitle": "Нашият екип ще се свърже с Вас при първа възможност",
    "your-name-placeholder": "Вашето име",
    "your-phone-email-placeholder": "Телефон/Email",
    "your-message-placeholder": "Вашето съобщение",
    "button-send": "Изпрати",
    "appointments-paragraph-1": "Може да запазите час на телефон: 0884 64 87 11",
    "appointments-paragraph-2": "Уважаеми потребители, Бихме искали да Ви обърнем внимание, че в случай, че имате непокрити задължения, те ще бъдат изисквани на регистратура.",
    "choose-hospital": "МЦ \"Уни Хоспитал\" - София",
    "choose-specialty": "Изберете специалност",
    "patients-age": "Възраст на пациента",
    "about-heading-title-1": "Оказваme",
    "about-heading-title-2": "високоспециализирана",
    "about-heading-title-3": "извънболнична",
    "about-heading-title-4": "медицинска помощ",
    "about-highlight-1": "Пациентът е в центъра на нашата грижа",
    "about-highlight-2": "Индивидуален подход",
    "about-highlight-3": "Удобство и комфорт",
    "about-highlight-4": "Комфорт за пациентите",
    "about-paragraph-title-1": "КАБИНЕТИ",
    "about-paragraph-title-2": "ЕКИП",
    "about-paragraph-title-3": "ПАЦИЕНТЪТ",
    "about-paragraph-description-1": "Кабинетите са оборудване с необходимата за консултативно-диагностична дейност, медицинска апаратура, изделия, инструменти и пособия.",
    "about-paragraph-description-2": "Екипът от утвърдени специалисти в медицинския център ще помогне на повече хора с първокласни медицински услуги - диагностична, терапевтична и превантивна дейност.",
    "about-paragraph-description-3": "е в центъра на нашата гружа. \n" +
        "Индивидуален подход и отношение, персонализиране, комплексна и качествена помощ за пациентите в комфортна среда. ",
    "about-equipment-title": "Оборудване",
    "about-equipment-description": "Пациентите имат възможност да се възползват от високотехнологичната апаратура, иновативните технологии за диагностика \n" +
        "и методи на лечение.",
    "about-hospital-background-title": "Сътрудничество с Уни Хоспитал Панагюрище",
    "about-hospital-background-subtitle": "Най-голямата и модерна болница в България",
    "about-hospital-background-description": "Медицински център „Уни Хоспитал“ - София ще отговори на повишения интерес на пациенти от чужбина към болницата в Панагюрище, с която ще изгради трайно и ефективно партньорство с цел подобряване и улесняване на достъпа им при пътуване за лечение в България.",
    "about-hotel-title": "Хотел “Земята и хората”",
    "about-hotel-subtitle": "Комфорт и удобство",
    "about-hotel-description": "Леснодостъпен по Околовръстния път на София, в непосредствена близост до два основни столични пътя, хотел „Земята и хората” предлага възможност за пълноценна почивка на спокойно място, съчетана с отлични условия за бизнес, конференции, лични или бизнес събития .",
    "about-hotel-highlight-1": "СПА",
    "about-hotel-highlight-2": "Фитнес",
    "about-hotel-highlight-3": "Ресторант",
    "about-hotel-highlight-4": "Бар",
    "about-hotel-highlight-5": "Специални оферти",
    "about-hotel-additional-information": "На разположение на гостите са луксозно обзаведени, светли стаи и апартаменти с безплатен интернет. Ресторант, лоби бар и скай бар с уникална панорамна гледка към София и Витоша са готови да посрещнат всички любители на добрата кухня и качествените питиета. СПА центърът предлага богато разнообразие от релаксиращи процедури за всички гости на хотела, а добре оборудваните заседателни и конферентни зали правят „Земята и Хората” перфектно място за провеждане на конференции и семинари.",
    "venous-center-heading-title": "Венозен център",
    "venous-center-heading-description": "Ние във Венозен център на „МЦ Уни Хоспитал“ – София вярваме, че Вие избирате не просто място и екип, а хора на които да доверите грижата за най-ценното – Вашето здраве.",
    "venous-center-highlight-1": "Ново поколение оборудване",
    "venous-center-highlight-2": "Най-високо ниво медицински специалисти",
    "venous-center-highlight-3": "Най-новите методи за консервативно и ендовенозно лечение",
    "venous-center-highlight-4": "Доверие и грижа към пациента",
    "venous-center-thumb-title-1": "Хроничната венозна болест",
    "venous-center-thumb-title-2": "Варикозните вени",
    "venous-center-thumb-title-3": "Симптоми на хроничната венозна болест",
    "venous-center-thumb-title-4": "Рецидивни варикозни вени",
    "venous-center-thumb-title-5": "Венозни рани",
    "venous-center-services-title": "Защо да изберем Венозния център на Медицински център Уни Хоспитал - София? ",
    "venous-center-services-paragraph-1": "Венозният център на „МЦ Уни Хоспитал“ – София разполага с последно поколение оборудване за лечение на разширени вени, а медицинските специалисти, работещи в него са с най-високо ниво на компетентност. Млади и иновативни, специализирани в най-новите методи за консервативно и ендовенозно лечение на хронична венозна болест членовете на екипа са винаги готови да откликнат на индивидуалните нужди на пациента и да го подкрепят по пътя на неговото лечение.",
    "venous-center-services-paragraph-2": "Ние във Венозен център на „МЦ Уни Хоспитал“ – София  вярваме, че Вие избирате не просто място и екип, а хора на които да доверите грижата за най-ценното – Вашето здраве.",
    "venous-center-additional-services-title": "Лечение на варикозните вени на долните крайници?",
    "contact-form-error": "Грешка! Моля опитай по-късно.",
    "contact-form-success": "Съoбщението беше изпратено успешно!",
    "apply-filters-button": "Избери",
    "full-care-title": "Пълна грижа за Вашето здраве",
    "full-care-paragraph": "Медицински център „Уни Хоспитал“ – София осигурява високоспециализирана извънболнична медицинска помощ за пациентите и своите партньори - общопрактикуващите лекари и специалистите от извънболничната помощ. Екипът ни е от доказани в областта си специалисти с дългогодишна практика, а апаратурата е от най-съвременен тип за профилактика, диагностика, лечение и извършване на високоспециализирани медицински дейности.",
    "full-care-button": "Всички Заболявания",
    "full-care-description": "Медицински център „Уни Хоспитал“ – София осигурява високоспециализирана извънболнична медицинска помощ за пациентите и своите партньори - общопрактикуващите лекари и специалистите от извънболничната помощ.\n" +
        "Екипът ни е от доказани в областта си специалисти с дългогодишна практика, а апаратурата е от най-съвременен тип за профилактика, диагностика, лечение и извършване на високоспециализирани медицински дейности.\n" +
        "МЦ „Уни Хоспитал“ – София продължава мисията на МБАЛ „УниХоспитал“, Панагюрище, за да подобри и улесни достъпа на пациентите до качествена медицинска помощ, както и пътуващите за лечение в България. В сътрудничество двете лечебни заведения са посветени на навременната диагностика на редица заболявания, сред които: ",
    "about-hotel-button": "Към хотела",
    "hospital-button": "Към болницата",
}